import { Swiper } from 'swiper';
import {
	A11y,
	Navigation,
	EffectFade,
	Pagination,
	Autoplay,
} from 'swiper/modules';

const sliders = document.querySelectorAll('.block-hero-slider .swiper');

if (sliders.length > 0) {
	sliders.forEach((slider, index) => {
		//const slides = slider.querySelectorAll('.swiper-slide');

		slider.parentElement.classList.add(
			`block-hero-slider__swiper--${index}`
		);

		const pauseButton = slider.parentElement.querySelector(
			'.swiper-button-pause'
		);
		console.log('Slider index:', index, 'Pause button:', pauseButton);

		const settings = {
			autoplay: {
				delay: 2500,
				disableOnInteraction: false,
			},
			loop: false,
			grabCursor: true,
			touchRatio: 0,
			spaceBetween: 0,
			slidesPerView: 1,
			clickable: true,
			slideToClickedSlide: true,
			modules: [A11y, Navigation, EffectFade, Pagination, Autoplay],
			effect: 'fade',
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl: `.block-hero-slider__swiper--${index} .swiper-button-prev`,
				nextEl: `.block-hero-slider__swiper--${index} .swiper-button-next`,
			},
			pagination: {
				el: `.block-hero-slider__swiper--${index} .swiper-pagination`,
				clickable: true,
			},
		};

		const swiper = new Swiper(slider, settings);

		if (pauseButton) {
			console.log('Pause button found for slider index:', index);
			pauseButton.addEventListener('click', () => {
				console.log('Pause button clicked for slider index:', index);
				pauseButton.classList.toggle('is-paused');
				if (pauseButton.classList.contains('is-paused')) {
					swiper.autoplay.stop();
				} else {
					swiper.autoplay.start();
				}
			});
		}
	});
}
